import { CreateForm, FormFieldsData, FormTemplateProps } from 'framework/form';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import StaffingNoteForm from './StaffingNoteForm';
import useStaffingNotesService from './staffingNotesService';

interface CreateStaffingNoteFormProps extends Omit<FormTemplateProps, 'children'> {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
}

const CreateStaffingNoteForm = ({ submitFormFunc, onCancel, ...props }: CreateStaffingNoteFormProps) => {
  const { getValidationSchema } = useStaffingNotesService();
  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getValidationSchema} {...props}>
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <StaffingNoteForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateStaffingNoteForm;
